(function () {
  function visibleTabs(tabs) { return tabs.filter(function (t) { return !t.hidden; }); }

  function init(root) {
    if (!root || root.dataset.pitReady) return;
    root.dataset.pitReady = '1';
    var tabs = [].slice.call(root.querySelectorAll('.pit__tab'));
    var panels = [].slice.call(root.querySelectorAll('.pit__panel'));
    // We handle scroll position ourselves; stop the browser's own scroll anchoring double-correcting
    root.style.overflowAnchor = 'none';

    // Keep the clicked tab/header in the same spot on screen while content above or below it changes height
    function keepInPlace(el, change) {
      var before = el.getBoundingClientRect().top;
      change();
      var after = el.getBoundingClientRect().top;
      var delta = after - before;
      if (Math.abs(delta) > 1) window.scrollBy(0, delta);
    }

    function activate(id, focus) {
      tabs.forEach(function (t) {
        var on = t.dataset.target === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.id === id); });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { keepInPlace(t, function () { activate(t.dataset.target); }); });
      t.addEventListener('keydown', function (e) {
        var vis = visibleTabs(tabs), i = vis.indexOf(t), next = null;
        if (e.key === 'ArrowRight') next = vis[(i + 1) % vis.length];
        else if (e.key === 'ArrowLeft') next = vis[(i - 1 + vis.length) % vis.length];
        else if (e.key === 'Home') next = vis[0];
        else if (e.key === 'End') next = vis[vis.length - 1];
        if (next) { e.preventDefault(); activate(next.dataset.target, true); }
      });
    });

    [].slice.call(root.querySelectorAll('.pit__acc')).forEach(function (b) {
      b.addEventListener('click', function () {
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (!p) return;
        var open = !p.classList.contains('is-open');
        keepInPlace(b, function () {
          // One section open at a time, like the desktop tabs
          [].slice.call(root.querySelectorAll('.pit__acc')).forEach(function (other) {
            var op = document.getElementById(other.getAttribute('aria-controls'));
            if (op) op.classList.remove('is-open');
            other.setAttribute('aria-expanded', 'false');
          });
          p.classList.toggle('is-open', open);
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) activate(p.id);
        });
      });
    });

    [].slice.call(root.querySelectorAll('[data-pit-scroll]')).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var w = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-widget.jdgm-all-reviews-widget');
        if (w) { e.preventDefault(); w.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });

    function removeItem(panel) {
      var item = panel.closest('.pit__item');
      var tab = root.querySelector('.pit__tab[data-target="' + panel.id + '"]');
      var wasActive = panel.classList.contains('is-active');
      if (tab) tab.hidden = true;
      if (item) item.hidden = true;
      if (wasActive) {
        var first = visibleTabs(tabs)[0];
        if (first) {
          activate(first.dataset.target);
          var fp = document.getElementById(first.dataset.target);
          if (fp) {
            fp.classList.add('is-open');
            var acc = root.querySelector('.pit__acc[aria-controls="' + fp.id + '"]');
            if (acc) acc.setAttribute('aria-expanded', 'true');
          }
        }
      }
    }

    var brand = root.querySelector('[data-pit-brand]');
    if (!brand) return;
    var app = brand.querySelector('[data-pit-app]');
    var fallback = brand.querySelector('[data-pit-fallback]');
    var panel = brand.closest('.pit__panel');
    var TITLES = ['about the brand', 'about us'];
    var done = false, observer = null, timer = null;

    function appText() {
      if (!app) return '';
      // Visible text only: ignore scripts, styles and other non-content markup the app injects
      var clone = app.cloneNode(true);
      [].slice.call(clone.querySelectorAll('script,style,noscript,template,link,meta,svg,iframe,input,button')).forEach(function (n) { n.remove(); });
      [].slice.call(clone.querySelectorAll('[hidden],[aria-hidden="true"]')).forEach(function (n) { n.remove(); });
      var t = (clone.textContent || '').replace(/\s+/g, ' ').trim();
      var lower = t.toLowerCase();
      TITLES.forEach(function (title) {
        if (lower.indexOf(title) === 0) { t = t.slice(title.length).trim(); lower = t.toLowerCase(); }
      });
      return t;
    }

    function hideAppTitle() {
      [].slice.call(app.querySelectorAll('h1,h2,h3,h4,h5,h6,p,div,span,strong,b')).forEach(function (el) {
        if (el.children.length === 0 && TITLES.indexOf((el.textContent || '').trim().toLowerCase()) !== -1) {
          el.style.display = 'none';
        }
      });
    }

    function finish() {
      if (done) return;
      done = true;
      if (observer) observer.disconnect();
      if (timer) clearTimeout(timer);
      brand.classList.remove('is-pending');
      if (app && appText().length > 15) {
        hideAppTitle();
        if (fallback) fallback.remove();
        return;
      }
      if (app) app.remove();
      if (fallback) { fallback.hidden = false; return; }
      var empty = brand.querySelector('[data-pit-empty]');
      if (empty) { empty.hidden = false; return; }
      removeItem(panel);
    }

    if (!app) { finish(); return; }
    if (appText().length > 15) { finish(); return; }
    observer = new MutationObserver(function () { if (appText().length > 15) finish(); });
    observer.observe(app, { childList: true, subtree: true, characterData: true });
    timer = setTimeout(finish, 2500);
  }

  function initAll() { [].slice.call(document.querySelectorAll('[data-pit]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-pit]')); });
})();
